import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
// Third party packages
import { MatDialog } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize, take } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { CompaniesService } from "src/app/modules/companies/companies.service";
import { UsersService } from "src/app/modules/users/users.service";
import { ConfirmDialogComponent } from "src/app/shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import { User } from "src/app/shared/models/user/user.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
var UserDetailComponent = /** @class */ (function () {
    /**
     * Class constructor
     */
    function UserDetailComponent(configService, activatedRoute, usersService, router, toastrService, helperService, translateService, themeService, authService, dialog, cookieService, companiesService, apiService // DO NOT MOVE since it's used for 'autocomplete' field type
    ) {
        this.configService = configService;
        this.activatedRoute = activatedRoute;
        this.usersService = usersService;
        this.router = router;
        this.toastrService = toastrService;
        this.helperService = helperService;
        this.translateService = translateService;
        this.themeService = themeService;
        this.authService = authService;
        this.dialog = dialog;
        this.cookieService = cookieService;
        this.companiesService = companiesService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        this.user = new User();
        this.roles = [];
        this.subPropertiesFormly = [];
        // BEGIN - Edit user form
        this.form = new FormGroup({});
        this.formPassword = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        this.modelPassword = {};
        this.fieldsPassword = [];
        this.optionsPassword = {};
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.formPasswordBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
        this.deleteBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.delete"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "warn",
            spinnerColor: "warn",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-trash",
                inline: true,
            },
        };
        // END - Edit user form
        this.detailCardIsLoading = true;
        this.deleteCardIsLoading = true;
        this.paswordCardIsLoading = true;
        this.previousPermissions = {
            unlimited: false,
            administration: false,
            editCompanies: false,
            insertPaperDoc: false,
            properties: false,
            docSearch: false,
            timetable: false,
            companies: false,
            insertDigitalDoc: false,
            email: false,
            temporaries: false,
            users: false,
            delDoc: false,
            delAgreement: false,
            editDocData: false,
            propertiesUnlimited: false,
            alertLastDocs: false,
        };
        this.preventFirstChange = false;
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Subscribe to current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        // Load correct data into component basing on url params
        if (this.activatedRoute.params) {
            this.subscriptions.push(this.activatedRoute.params.subscribe(function (res) {
                if (res) {
                    console.log("res", res);
                    if (res.lang) {
                        _this.lang = res.lang;
                    }
                    if (res.adminCompanyId) {
                        _this.adminCompanyId = res.adminCompanyId;
                    }
                    _this.handleRouteParamsChange();
                }
            }, function (err) {
                // if we came here users with given userId do not exist
                _this.router.navigate([_this.lang, "errors", "404"]);
            }));
        }
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Init component
     */
    UserDetailComponent.prototype.handleRouteParamsChange = function () {
        var _this = this;
        // Activate spinner
        this.detailCardIsLoading = true;
        this.paswordCardIsLoading = true;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("users.detail.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) {
            _this.loggedUser = res;
            // this.loggedUserRole = this.authService.loggedUserRequestedRole$.getValue();
        }));
        this.subscriptions.push(this.authService.loggedUserPermissions$.subscribe(function (res) { return (_this.loggedUserPermissions = res); }));
        this.subscriptions.push(this.authService.loggedUserRequestedRoleObj$.subscribe(function (res) { return (_this.loggedUserObj = res); }));
        // Get requested user data
        var userId = this.activatedRoute.snapshot.params.userId;
        // Admin/Operator: this param is useful to Admin and operator to manipulate
        // the user correct role, in relate to company
        var adminCompanyId = this.activatedRoute.snapshot.params.adminCompanyId;
        this.subscriptions.push(this.usersService.get(userId).subscribe(function (res) {
            if (res.status) {
                // Get user data
                _this.user.setData(res.data);
                _this.userFullName = _this.user.get("firstName") + " " + _this.user.get("lastName");
                _this.userRoles = _this.user.get("userRoles");
                // Stop loading delete form
                _this.deleteCardIsLoading = false;
                // Prevent form fields to be rendered twice on url params change
                _this.fields = [];
                // If logged user is admin/operator, he must see this user as admin/operator/tagger
                if (_this.authService.loggedUserRequestedRoleType$.getValue() ===
                    "admin" ||
                    _this.authService.loggedUserRequestedRoleType$.getValue() ===
                        "operator") {
                    // User cannot be either admin and operator, so return the first matched element
                    // If company subuser, get correct role
                    _this.displayedRole = _this.userRoles.find(function (obj) {
                        if (adminCompanyId) {
                            return (obj.company &&
                                obj.company._id &&
                                obj.company._id.toString() === adminCompanyId);
                        }
                        else {
                            var roleType = obj.role && obj.role.type
                                ? obj.role.type.toString()
                                : obj.type;
                            return (roleType === "admin" ||
                                roleType === "operator" ||
                                roleType === "tagger");
                        }
                    });
                    if (!_this.displayedRole) {
                        //this.router.navigate([this.lang, 'errors', '404']);
                        console.warn("err");
                    }
                }
                // Same thing for master/collaborator
                if (_this.authService.loggedUserRequestedRoleType$.getValue() ===
                    "master" ||
                    _this.authService.loggedUserRequestedRoleType$.getValue() ===
                        "collaborator") {
                    _this.displayedRole = _this.userRoles.find(function (obj) {
                        var roleObj = _this.authService.loggedUserRequestedRoleObj$.getValue();
                        var company = roleObj && roleObj.company ? roleObj.company._id : undefined;
                        var roleType = obj.role && obj.role.type
                            ? obj.role.type.toString()
                            : obj.type;
                        return ((roleType === "master" || roleType === "collaborator") &&
                            obj.company &&
                            obj.company._id === company);
                    });
                    if (!_this.displayedRole) {
                        _this.router.navigate([_this.lang, "errors", "404"]);
                    }
                }
                // Make form card visible by disabling his card-spinner
                _this.detailCardIsLoading = false;
                _this.paswordCardIsLoading = false;
                _this.getCompany(userId, _this.displayedRole);
                return;
            }
            // Something bad happened
            // redirect user to home
            _this.router.navigate([_this.lang, "app", "users", "list"]);
        }, function (err) {
            // if we came here users with given userId do not exist
            _this.router.navigate([_this.lang, "errors", "404"]);
        }));
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.initForm = function () {
        var _this = this;
        // Set model
        var userData = this.user.getData();
        this.model = userData;
        this.model.generalPermission = this.displayedRole.generalPermission;
        // Set fields
        this.fields = [
            {
                fieldGroupClassName: "row",
                fieldGroup: tslib_1.__spread([
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "firstName",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.firstName"),
                            placeholder: this.translateService.instant("users.fields.firstName"),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "lastName",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.lastName"),
                            placeholder: this.translateService.instant("users.fields.lastName"),
                            required: true,
                            minLength: 2,
                            maxLength: 50,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "taxCode",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.taxCode"),
                            placeholder: this.translateService.instant("users.fields.taxCode"),
                            required: false,
                            minLength: 0,
                            maxLength: 20,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "phone",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.phone"),
                            placeholder: this.translateService.instant("users.fields.phone"),
                            required: false,
                            minLength: 1,
                            maxLength: 15,
                            pattern: this.configService.phonePattern,
                        },
                    },
                    {
                        className: "col-12",
                        type: "address",
                        key: "address",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.address"),
                            placeholder: this.translateService.instant("users.fields.address"),
                            required: false,
                        },
                    },
                    {
                        className: "section-label col-12",
                        template: "<hr /><div><strong>" +
                            this.translateService.instant("users.fields.generalPermission.title") +
                            "</strong></div>",
                    },
                    {
                        key: "userRoleId",
                        defaultValue: this.displayedRole._id,
                    },
                    {
                        className: "col-12 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.unlimited",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.unlimited.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.unlimited.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.required": "model.types && model.types.includes('manager')",
                            "templateOptions.change": function (model, formState, field) {
                                if (!_this.preventFirstChange) {
                                    _this.preventFirstChange = true;
                                }
                                else {
                                    var key = field.key;
                                    var subKey = key.replace("generalPermission.", "");
                                    if (_this.previousPermissions[subKey] !=
                                        model.generalPermission[subKey]) {
                                        _this.previousPermissions[subKey] =
                                            model.generalPermission[subKey];
                                        _this.managePermissionCheckbox(model, field, subKey);
                                    }
                                }
                            },
                        },
                    },
                    {
                        className: "col-12 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.tagger",
                        defaultValue: false,
                        hideExpression: this.displayedRole.role.type !== "admin" &&
                            this.displayedRole.role.type !== "operator" &&
                            this.displayedRole.role.type !== "tagger",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.tagger.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.tagger.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.administration",
                        defaultValue: false,
                        hideExpression: this.displayedRole.role.type !== "admin" &&
                            this.displayedRole.role.type !== "operator",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.administration.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.administration.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.editCompanies",
                        defaultValue: false,
                        hideExpression: this.displayedRole.role.type !== "admin" &&
                            this.displayedRole.role.type !== "operator",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.editCompanies.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.editCompanies.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.companies",
                        defaultValue: false,
                        hideExpression: this.displayedRole.role.type === "admin" ||
                            this.displayedRole.role.type === "operator" ||
                            this.displayedRole.role.type === "tagger",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.companies.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.companies.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-12 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.properties",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.properties.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.properties.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.timetable",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.timetable.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.timetable.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.docSearch",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.docSearch.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.docSearch.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.insertPaperDoc",
                        defaultValue: false,
                        hideExpression: this.displayedRole.role.type !== "admin" &&
                            this.displayedRole.role.type !== "operator",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.insertPaperDoc.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.insertPaperDoc.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.insertDigitalDoc",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.insertDigitalDoc.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.insertDigitalDoc.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.delDoc",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.delDoc.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.delDoc.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.delAgreement",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.delAgreement.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.delAgreement.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-12 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.editDocData",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.editDocData.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.editDocData.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.temporaries",
                        defaultValue: false,
                        hideExpression: this.displayedRole.role.type === "admin" ||
                            this.displayedRole.role.type === "operator" ||
                            this.displayedRole.role.type === "tagger",
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.temporaries.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.temporaries.placeholder"),
                        },
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.users",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.users.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.users.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.email",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.email.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.email.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        className: "col-4 checkbox-field",
                        type: "checkbox",
                        key: "generalPermission.alertLastDocs",
                        defaultValue: false,
                        templateOptions: {
                            label: this.translateService.instant("users.fields.generalPermission.alertLastDocs.label"),
                            placeholder: this.translateService.instant("users.fields.generalPermission.alertLastDocs.placeholder"),
                        },
                        hideExpression: this.displayedRole.role.type === "tagger",
                        expressionProperties: {
                            "templateOptions.onClick": function (model, formState, field) {
                                var key = field.key;
                                var subKey = key.replace("generalPermission.", "");
                                if (_this.previousPermissions[subKey] !=
                                    model.generalPermission[subKey]) {
                                    _this.previousPermissions[subKey] =
                                        model.generalPermission[subKey];
                                    _this.managePermissionCheckbox(model, field, subKey);
                                }
                            },
                        },
                    },
                    {
                        key: "userCompanyId",
                        defaultValue: this.displayedRole.company
                            ? this.displayedRole.company._id
                            : "",
                    }
                ], this.subPropertiesFormly),
            },
        ];
        this.fieldsPassword = [
            {
                key: "newPassword",
                validators: {
                    fieldMatch: {
                        expression: function (control) {
                            var value = control.value;
                            return (value.confirmPassword === value.password ||
                                // avoid displaying the message error when values are empty
                                !value.confirmPassword ||
                                !value.password);
                        },
                        message: this.translateService.instant("dialogs.changePassword.password_not_matching"),
                        errorPath: "confirmPassword",
                    },
                },
                fieldGroupClassName: "row",
                fieldGroup: [
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "password",
                        templateOptions: {
                            label: this.translateService.instant("dialogs.changePassword.password"),
                            placeholder: this.translateService.instant("dialogs.changePassword.password"),
                            required: true,
                            minLength: 5,
                            maxLength: 100,
                            type: "password",
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "confirmPassword",
                        templateOptions: {
                            label: this.translateService.instant("dialogs.changePassword.confirmPassword"),
                            placeholder: this.translateService.instant("dialogs.changePassword.confirmPassword"),
                            required: true,
                            type: "password",
                        },
                    },
                ],
            },
        ];
    };
    /**
     * set/unset all permission checkbox on the unlimited permission change event
     */
    UserDetailComponent.prototype.managePermissionCheckbox = function (model, field, subKey) {
        var userType = this.displayedRole.type;
        if (subKey !== "unlimited") {
            if (((userType === "admin" || userType === "operator") &&
                subKey !== "companies" &&
                subKey !== "temporaries") ||
                ((userType === "master" || userType === "collaborator") &&
                    subKey !== "administration" &&
                    subKey !== "editCompanies" &&
                    subKey !== "insertPaperDoc")) {
                this.previousPermissions[subKey] = model.generalPermission[subKey];
                var allChkTrue = true;
                for (var property in model.generalPermission) {
                    if (property !== "unlimited") {
                        allChkTrue = allChkTrue && model.generalPermission[property];
                    }
                }
                if (allChkTrue) {
                    this.previousPermissions.unlimited = false;
                    model.generalPermission.unlimited = false;
                    this.form.get("generalPermission.unlimited").setValue(true);
                }
                else {
                    this.previousPermissions.unlimited = false;
                    model.generalPermission.unlimited = false;
                    this.form.get("generalPermission.unlimited").setValue(false);
                }
            }
        }
        else {
            for (var property in model.generalPermission) {
                if (typeof this.form.value.generalPermission[property] !== "undefined") {
                    this.form
                        .get("generalPermission." + property)
                        .setValue(model.generalPermission.unlimited);
                    this.previousPermissions[property] =
                        model.generalPermission.unlimited;
                }
            }
        }
    };
    /**
     * set/unset all permission checkbox on the unlimited permission change event
     */
    UserDetailComponent.prototype.managePropertiesPermissionCheckbox = function (model, field, subKey) {
        if (subKey !== "propertiesUnlimited") {
            if (!this.previousPermissions[subKey]) {
                this.previousPermissions.propertiesUnlimited = false;
                model.propsPermission.propertiesUnlimited = false;
                this.form.get("propsPermission.propertiesUnlimited").setValue(false);
            }
        }
        else {
            for (var property in model.subProperties) {
                if (typeof this.form.value.subProperties[property] !== "undefined") {
                    this.form
                        .get("subProperties." + property)
                        .setValue(model.propsPermission.propertiesUnlimited);
                }
            }
        }
    };
    /**
     * Get company subProp data
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.getCompany = function (userId, selectedRole) {
        var _this = this;
        this.subPropertiesFormly = [];
        if (!selectedRole) {
            this.toastrService.error("Questo utente è da aggiornare con i nuovi ruoli"); // @todo rimuovere quando non serve più
            return;
        }
        // Get company data
        if (selectedRole &&
            (selectedRole.role.type === "master" ||
                selectedRole.role.type === "collaborator")) {
            this.companyId = selectedRole.company._id;
            // get all properties that user logged can manage
            this.companiesService.get(this.companyId).subscribe(function (res) {
                var _a;
                if (res.status) {
                    var subProperties = res.data.subProperties;
                    subProperties = subProperties
                        .filter(function (el) { return el.active; })
                        .sort(function (a, b) {
                        return _this.compare(a.name.toLowerCase(), b.name.toLowerCase(), true);
                    });
                    if (Array.isArray(subProperties) && subProperties) {
                        var items_1 = [];
                        var item = {
                            className: "section-label col-12",
                            template: "<hr><br /><div><strong>" +
                                _this.translateService.instant("users.fields.companyPermission.title") +
                                "</strong></div>",
                        };
                        items_1.push(item);
                        var item2 = {
                            className: "col-12 checkbox-field",
                            type: "checkbox",
                            key: "propsPermission.propertiesUnlimited",
                            defaultValue: _this.previousPermissions["propertiesUnlimited"],
                            templateOptions: {
                                label: _this.translateService.instant("users.fields.generalPermission.unlimited.label"),
                                placeholder: _this.translateService.instant("users.fields.generalPermission.unlimited.placeholder"),
                            },
                            expressionProperties: {
                                "templateOptions.required": "model.types && model.types.includes('manager')",
                                "templateOptions.onClick": function (model, formState, field) {
                                    var key = field.key;
                                    var subKey = key.replace("propsPermission.", "");
                                    if (_this.previousPermissions[subKey] !=
                                        model.propsPermission[subKey]) {
                                        _this.previousPermissions[subKey] =
                                            model.propsPermission[subKey];
                                        _this.managePropertiesPermissionCheckbox(model, field, subKey);
                                    }
                                },
                            },
                        };
                        items_1.push(item2);
                        subProperties.forEach(function (elem) {
                            if (elem.active) {
                                var defaultValue = true;
                                if (Array.isArray(elem.unauthUsers) && elem.unauthUsers) {
                                    var index = elem.unauthUsers.findIndex(function (item) {
                                        return item === userId;
                                    });
                                    if (index > -1) {
                                        defaultValue = false;
                                    }
                                }
                                _this.previousPermissions["subProperties." + elem.propertyId] =
                                    defaultValue;
                                var item_1 = {
                                    className: "col-4 checkbox-field",
                                    type: "checkbox",
                                    key: "subProperties." + elem.propertyId,
                                    defaultValue: defaultValue,
                                    templateOptions: {
                                        label: elem.name,
                                    },
                                    expressionProperties: {
                                        "templateOptions.onClick": function (model, formState, field) {
                                            var key = field.key;
                                            var subKey = key.replace("subProperties.", "");
                                            if (_this.previousPermissions[subKey] !=
                                                model.subProperties[subKey]) {
                                                _this.previousPermissions[subKey] =
                                                    model.subProperties[subKey];
                                                _this.managePropertiesPermissionCheckbox(model, field, subKey);
                                            }
                                        },
                                    },
                                };
                                items_1.push(item_1);
                            }
                        });
                        (_a = _this.subPropertiesFormly).push.apply(_a, tslib_1.__spread(items_1));
                    }
                    _this.initForm();
                    return;
                }
            }, function (err) {
                _this.helperService.handleError(err);
            });
        }
        else {
            this.initForm();
        }
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.form);
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        // Remove blank values form model
        Object.keys(model).forEach(function (key) {
            if (typeof model[key] === "string" && model[key].trim() === "") {
                model[key] = undefined;
            }
        });
        this.subscriptions.push(this.usersService
            .update(this.user.getId(), model)
            .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
            .subscribe(function (res) {
            if (res) {
                _this.toastrService.success(res.message);
                // Reload page
                _this.handleRouteParamsChange();
                if (_this.loggedUser._id === _this.user.getId()) {
                    _this.authService.updatedLoggedUserData();
                }
            }
        }, function (err) {
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Handle password form submit
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.onFormPasswordSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.formPassword.invalid) {
            Object.keys(this.formPassword.controls).forEach(function (key) {
                _this.formPassword.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.formPassword);
            return;
        }
        // Activate submit button loading status
        this.formPasswordBtnOptions.active = true;
        var data = {
            password: model.newPassword.password,
        };
        this.subscriptions.push(this.usersService
            .updateFields(this.user.getId(), data)
            .pipe(finalize(function () { return (_this.formPasswordBtnOptions.active = false); }))
            .subscribe(function (res) {
            if (res) {
                _this.toastrService.success(res.message);
                _this.optionsPassword.resetModel();
                // Reload page
                _this.handleRouteParamsChange();
                if (_this.loggedUser._id === _this.user.getId()) {
                    _this.authService.updatedLoggedUserData();
                }
            }
        }, function (err) {
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    /**
     * Remove current user from database
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.onDelete = function () {
        var _this = this;
        var dialogRef = this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: this.translateService.instant("dialogs.confirm.title"),
                message: this.translateService.instant("dialogs.confirm.message"),
                btnOkText: this.translateService.instant("common.cta.confirm"),
                btnCancelText: this.translateService.instant("common.cta.undo"),
            },
            width: "500px",
        });
        // Subscribe to dialog result (only for 1 emit thanks to "take()")
        dialogRef
            .beforeClosed()
            .pipe(take(1))
            .subscribe(function (res) {
            if (!res) {
                return;
            }
            var paramCompanyId = undefined;
            if (typeof _this.adminCompanyId !== "undefined" &&
                _this.adminCompanyId !== "") {
                paramCompanyId = _this.adminCompanyId;
            }
            else if (_this.loggedUserObj.role.type === "master" ||
                _this.loggedUserObj.role.type === "collaborator") {
                paramCompanyId = _this.loggedUserObj.company._id;
            }
            _this.subscriptions.push(_this.usersService
                .delete(_this.user.getId(), paramCompanyId)
                .pipe(finalize(function () { return (_this.deleteBtnOptions.active = false); }))
                .subscribe(function (res2) {
                _this.toastrService.success(res2.message);
                if (_this.adminCompanyId && _this.adminCompanyId !== "") {
                    // Once the user is deleted, redirect to list
                    _this.router.navigate([
                        _this.lang,
                        "app",
                        "companies",
                        "detail",
                        _this.adminCompanyId,
                    ]);
                }
                else {
                    // Once the user is deleted, redirect to list
                    _this.router.navigate([_this.lang, "app", "users", "list"]);
                }
                return;
            }, function (err) {
                // Choose one of the following error handling
                // method. The first one shows a message right
                // under the form fields (if the form is properly
                // setted), the second one shows toastr
                // notifications for each error
                // this.helperService.handleFormError(this.passwordForm, err);
                _this.helperService.handleError(err);
            }));
        });
    };
    /**
     * Utility per table sort
     *
     * @since 1.0.0
     */
    UserDetailComponent.prototype.compare = function (a, b, isAsc) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    };
    return UserDetailComponent;
}());
export { UserDetailComponent };
